interface PlansTabsProps {
  tiers: string[]
  active: string
  onChange: (tier: string) => void
}

/**
 * Tabs para seleccionar entre tiers de planes (Básico/Intermedio/Élite).
 * Usa la fuente Unbounded (cargada vía Google Fonts en index.html).
 * Accesible: role="tablist" + role="tab" + aria-selected.
 */
export function PlansTabs({ tiers, active, onChange }: PlansTabsProps) {
  return (
    <div className="plans-tabs" role="tablist" aria-label="Selecciona un tier">
      {tiers.map((name) => (
        <button
          key={name}
          type="button"
          role="tab"
          aria-selected={active === name}
          className={'plans-tab' + (active === name ? ' plans-tab--active' : '')}
          onClick={() => onChange(name)}
        >
          {name}
        </button>
      ))}
    </div>
  )
}